/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Plugin } from '../models/plugin';
import { DataBusStatus } from '../models/data-bus-status';
import { DataBusStatusResponse } from '../models/data-bus-status-response';
import { DataBusLicense } from '../models/data-bus-license';
import { DatabusLicenseFile } from '../models/databus-license-file';
@Injectable({
  providedIn: 'root',
})
class DataBusService extends __BaseService {
  static readonly DataBusGetPluginsPath = '/api/DataBus/GetPlugins';
  static readonly DataBusDeleteDataBusStatusPath = '/api/DataBus/DeleteDataBusStatus/{id}';
  static readonly DataBusDeleteDataBusLicensePath = '/api/DataBus/DeleteDataBusLicense/{id}';
  static readonly DataBusGetDataBusStatusListPath = '/api/DataBus/GetStatusList';
  static readonly DataBusUpdateStatusPath = '/api/DataBus/UpdateStatus';
  static readonly DataBusGetPricePath = '/api/DataBus';
  static readonly DataBusConvertToLicensePath = '/api/DataBus/ConvertToLicense/{dataBusStatusId}/{validFor}/{customerId}';
  static readonly DataBusRequestLicensePath = '/api/DataBus/RequestLicense';
  static readonly DataBusSaveOrderForUserPath = '/api/DataBus/SaveOrderForUser';
  static readonly DataBusCreateOrderForUserPath = '/api/DataBus/CreateOrderForUser';
  static readonly DataBusApproveOrderPath = '/api/DataBus/ApproveOrder';
  static readonly DataBusGetLicenseFilePath = '/api/DataBus/GetLicenseFile';
  static readonly DataBusGenerateLicenseFilePath = '/api/DataBus/GenerateLicenseFile';
  static readonly DataBusUpdateLicensePath = '/api/DataBus/UpdateLicense';
  static readonly DataBusGetCustomerLicensesPath = '/api/DataBus/GetCustomerLicenses';
  static readonly DataBusGetLicenseByIdPath = '/api/DataBus/GetLicenseById';
  static readonly DataBusGetLicensesForCustomerPath = '/api/DataBus/GetLicensesForCustomer';
  static readonly DataBusGetAllNewOrdersPath = '/api/DataBus/GetAllNewOrders';
  static readonly DataBusGetAllPaidOrdersPath = '/api/DataBus/GetAllPaidOrders';
  static readonly DataBusRevokeLicensePath = '/api/DataBus/RevokeLicense';
  static readonly DataBusRenewLicensePath = '/api/DataBus/RenewLicense';
  static readonly DataBusArchiveLicensePath = '/api/DataBus/ArchiveLicense';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  DataBusGetPluginsResponse(): __Observable<__StrictHttpResponse<Array<Plugin>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus/GetPlugins`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Plugin>>;
      })
    );
  }  DataBusGetPlugins(): __Observable<Array<Plugin>> {
    return this.DataBusGetPluginsResponse().pipe(
      __map(_r => _r.body as Array<Plugin>)
    );
  }

  /**
   * @param id undefined
   */
  DataBusDeleteDataBusStatusResponse(id: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/DataBus/DeleteDataBusStatus/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DataBusDeleteDataBusStatus(id: number): __Observable<Blob> {
    return this.DataBusDeleteDataBusStatusResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  DataBusDeleteDataBusLicenseResponse(id: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/DataBus/DeleteDataBusLicense/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DataBusDeleteDataBusLicense(id: number): __Observable<Blob> {
    return this.DataBusDeleteDataBusLicenseResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  DataBusGetDataBusStatusListResponse(): __Observable<__StrictHttpResponse<Array<DataBusStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus/GetStatusList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DataBusStatus>>;
      })
    );
  }  DataBusGetDataBusStatusList(): __Observable<Array<DataBusStatus>> {
    return this.DataBusGetDataBusStatusListResponse().pipe(
      __map(_r => _r.body as Array<DataBusStatus>)
    );
  }

  /**
   * @param status undefined
   */
  DataBusUpdateStatusResponse(status: DataBusStatus): __Observable<__StrictHttpResponse<DataBusStatusResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = status;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/UpdateStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusStatusResponse>;
      })
    );
  }
  /**
   * @param status undefined
   */
  DataBusUpdateStatus(status: DataBusStatus): __Observable<DataBusStatusResponse> {
    return this.DataBusUpdateStatusResponse(status).pipe(
      __map(_r => _r.body as DataBusStatusResponse)
    );
  }

  /**
   * @param uris undefined
   */
  DataBusGetPriceResponse(uris?: number): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (uris != null) __params = __params.set('uris', uris.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: parseFloat((_r as HttpResponse<any>).body as string) }) as __StrictHttpResponse<number>
      })
    );
  }
  /**
   * @param uris undefined
   */
  DataBusGetPrice(uris?: number): __Observable<number> {
    return this.DataBusGetPriceResponse(uris).pipe(
      __map(_r => _r.body as number)
    );
  }

  /**
   * @param params The `DataBusService.DataBusConvertToLicenseParams` containing the following parameters:
   *
   * - `validFor`:
   *
   * - `dataBusStatusId`:
   *
   * - `customerId`:
   */
  DataBusConvertToLicenseResponse(params: DataBusService.DataBusConvertToLicenseParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/ConvertToLicense/${encodeURIComponent(String(params.dataBusStatusId))}/${encodeURIComponent(String(params.validFor))}/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusConvertToLicenseParams` containing the following parameters:
   *
   * - `validFor`:
   *
   * - `dataBusStatusId`:
   *
   * - `customerId`:
   */
  DataBusConvertToLicense(params: DataBusService.DataBusConvertToLicenseParams): __Observable<DataBusLicense> {
    return this.DataBusConvertToLicenseResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }

  /**
   * @param params The `DataBusService.DataBusRequestLicenseParams` containing the following parameters:
   *
   * - `uriCount`:
   *
   * - `ServerToken`:
   *
   * - `ServerName`:
   *
   * - `LicensePlugins`:
   *
   * - `EmailAddress`:
   */
  DataBusRequestLicenseResponse(params: DataBusService.DataBusRequestLicenseParams): __Observable<__StrictHttpResponse<DatabusLicenseFile>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.uriCount != null) __params = __params.set('uriCount', params.uriCount.toString());
    if (params.ServerToken != null) __params = __params.set('ServerToken', params.ServerToken.toString());
    if (params.ServerName != null) __params = __params.set('ServerName', params.ServerName.toString());
    (params.LicensePlugins || []).forEach(val => {if (val != null) __params = __params.append('LicensePlugins', val.toString())});
    if (params.EmailAddress != null) __params = __params.set('EmailAddress', params.EmailAddress.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/RequestLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DatabusLicenseFile>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusRequestLicenseParams` containing the following parameters:
   *
   * - `uriCount`:
   *
   * - `ServerToken`:
   *
   * - `ServerName`:
   *
   * - `LicensePlugins`:
   *
   * - `EmailAddress`:
   */
  DataBusRequestLicense(params: DataBusService.DataBusRequestLicenseParams): __Observable<DatabusLicenseFile> {
    return this.DataBusRequestLicenseResponse(params).pipe(
      __map(_r => _r.body as DatabusLicenseFile)
    );
  }

  /**
   * @param params The `DataBusService.DataBusSaveOrderForUserParams` containing the following parameters:
   *
   * - `uriCount`:
   *
   * - `totalPrice`:
   *
   * - `licensesPlugins`:
   *
   * - `licenseName`:
   *
   * - `customerId`:
   */
  DataBusSaveOrderForUserResponse(params: DataBusService.DataBusSaveOrderForUserParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.uriCount != null) __params = __params.set('uriCount', params.uriCount.toString());
    if (params.totalPrice != null) __params = __params.set('totalPrice', params.totalPrice.toString());
    (params.licensesPlugins || []).forEach(val => {if (val != null) __params = __params.append('licensesPlugins', val.toString())});
    if (params.licenseName != null) __params = __params.set('licenseName', params.licenseName.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/SaveOrderForUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusSaveOrderForUserParams` containing the following parameters:
   *
   * - `uriCount`:
   *
   * - `totalPrice`:
   *
   * - `licensesPlugins`:
   *
   * - `licenseName`:
   *
   * - `customerId`:
   */
  DataBusSaveOrderForUser(params: DataBusService.DataBusSaveOrderForUserParams): __Observable<DataBusLicense> {
    return this.DataBusSaveOrderForUserResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }

  /**
   * @param params The `DataBusService.DataBusCreateOrderForUserParams` containing the following parameters:
   *
   * - `orderId`:
   *
   * - `customerId`:
   */
  DataBusCreateOrderForUserResponse(params: DataBusService.DataBusCreateOrderForUserParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.orderId != null) __params = __params.set('orderId', params.orderId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/CreateOrderForUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusCreateOrderForUserParams` containing the following parameters:
   *
   * - `orderId`:
   *
   * - `customerId`:
   */
  DataBusCreateOrderForUser(params: DataBusService.DataBusCreateOrderForUserParams): __Observable<DataBusLicense> {
    return this.DataBusCreateOrderForUserResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }

  /**
   * @param params The `DataBusService.DataBusApproveOrderParams` containing the following parameters:
   *
   * - `orderId`:
   *
   * - `validDays`:
   */
  DataBusApproveOrderResponse(params: DataBusService.DataBusApproveOrderParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.orderId;
    if (params.validDays != null) __params = __params.set('validDays', params.validDays.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/DataBus/ApproveOrder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusApproveOrderParams` containing the following parameters:
   *
   * - `orderId`:
   *
   * - `validDays`:
   */
  DataBusApproveOrder(params: DataBusService.DataBusApproveOrderParams): __Observable<Blob> {
    return this.DataBusApproveOrderResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `DataBusService.DataBusGetLicenseFileParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusGetLicenseFileResponse(params: DataBusService.DataBusGetLicenseFileParams): __Observable<__StrictHttpResponse<DatabusLicenseFile>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/GetLicenseFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DatabusLicenseFile>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusGetLicenseFileParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusGetLicenseFile(params: DataBusService.DataBusGetLicenseFileParams): __Observable<DatabusLicenseFile> {
    return this.DataBusGetLicenseFileResponse(params).pipe(
      __map(_r => _r.body as DatabusLicenseFile)
    );
  }

  /**
   * @param params The `DataBusService.DataBusGenerateLicenseFileParams` containing the following parameters:
   *
   * - `serverToken`:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusGenerateLicenseFileResponse(params: DataBusService.DataBusGenerateLicenseFileParams): __Observable<__StrictHttpResponse<DatabusLicenseFile>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.serverToken != null) __params = __params.set('serverToken', params.serverToken.toString());
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/GenerateLicenseFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DatabusLicenseFile>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusGenerateLicenseFileParams` containing the following parameters:
   *
   * - `serverToken`:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusGenerateLicenseFile(params: DataBusService.DataBusGenerateLicenseFileParams): __Observable<DatabusLicenseFile> {
    return this.DataBusGenerateLicenseFileResponse(params).pipe(
      __map(_r => _r.body as DatabusLicenseFile)
    );
  }

  /**
   * @param params The `DataBusService.DataBusUpdateLicenseParams` containing the following parameters:
   *
   * - `uriCount`:
   *
   * - `totalPrice`:
   *
   * - `licensesPlugins`:
   *
   * - `licenseName`:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusUpdateLicenseResponse(params: DataBusService.DataBusUpdateLicenseParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.uriCount != null) __params = __params.set('uriCount', params.uriCount.toString());
    if (params.totalPrice != null) __params = __params.set('totalPrice', params.totalPrice.toString());
    (params.licensesPlugins || []).forEach(val => {if (val != null) __params = __params.append('licensesPlugins', val.toString())});
    if (params.licenseName != null) __params = __params.set('licenseName', params.licenseName.toString());
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/DataBus/UpdateLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusUpdateLicenseParams` containing the following parameters:
   *
   * - `uriCount`:
   *
   * - `totalPrice`:
   *
   * - `licensesPlugins`:
   *
   * - `licenseName`:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusUpdateLicense(params: DataBusService.DataBusUpdateLicenseParams): __Observable<DataBusLicense> {
    return this.DataBusUpdateLicenseResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }

  /**
   * @param customerId undefined
   */
  DataBusGetCustomerLicensesResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<DataBusLicense>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus/GetCustomerLicenses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DataBusLicense>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DataBusGetCustomerLicenses(customerId?: number): __Observable<Array<DataBusLicense>> {
    return this.DataBusGetCustomerLicensesResponse(customerId).pipe(
      __map(_r => _r.body as Array<DataBusLicense>)
    );
  }

  /**
   * @param params The `DataBusService.DataBusGetLicenseByIdParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusGetLicenseByIdResponse(params: DataBusService.DataBusGetLicenseByIdParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus/GetLicenseById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusGetLicenseByIdParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusGetLicenseById(params: DataBusService.DataBusGetLicenseByIdParams): __Observable<DataBusLicense> {
    return this.DataBusGetLicenseByIdResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }

  /**
   * @param customerId undefined
   */
  DataBusGetLicensesForCustomerResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<DataBusLicense>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus/GetLicensesForCustomer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DataBusLicense>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DataBusGetLicensesForCustomer(customerId?: number): __Observable<Array<DataBusLicense>> {
    return this.DataBusGetLicensesForCustomerResponse(customerId).pipe(
      __map(_r => _r.body as Array<DataBusLicense>)
    );
  }
  DataBusGetAllNewOrdersResponse(): __Observable<__StrictHttpResponse<Array<DataBusLicense>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus/GetAllNewOrders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DataBusLicense>>;
      })
    );
  }  DataBusGetAllNewOrders(): __Observable<Array<DataBusLicense>> {
    return this.DataBusGetAllNewOrdersResponse().pipe(
      __map(_r => _r.body as Array<DataBusLicense>)
    );
  }
  DataBusGetAllPaidOrdersResponse(): __Observable<__StrictHttpResponse<Array<DataBusLicense>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DataBus/GetAllPaidOrders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DataBusLicense>>;
      })
    );
  }  DataBusGetAllPaidOrders(): __Observable<Array<DataBusLicense>> {
    return this.DataBusGetAllPaidOrdersResponse().pipe(
      __map(_r => _r.body as Array<DataBusLicense>)
    );
  }

  /**
   * @param params The `DataBusService.DataBusRevokeLicenseParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusRevokeLicenseResponse(params: DataBusService.DataBusRevokeLicenseParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/RevokeLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusRevokeLicenseParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusRevokeLicense(params: DataBusService.DataBusRevokeLicenseParams): __Observable<DataBusLicense> {
    return this.DataBusRevokeLicenseResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }

  /**
   * @param params The `DataBusService.DataBusRenewLicenseParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusRenewLicenseResponse(params: DataBusService.DataBusRenewLicenseParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/RenewLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusRenewLicenseParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusRenewLicense(params: DataBusService.DataBusRenewLicenseParams): __Observable<DataBusLicense> {
    return this.DataBusRenewLicenseResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }

  /**
   * @param params The `DataBusService.DataBusArchiveLicenseParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusArchiveLicenseResponse(params: DataBusService.DataBusArchiveLicenseParams): __Observable<__StrictHttpResponse<DataBusLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DataBus/ArchiveLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataBusLicense>;
      })
    );
  }
  /**
   * @param params The `DataBusService.DataBusArchiveLicenseParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `customerId`:
   */
  DataBusArchiveLicense(params: DataBusService.DataBusArchiveLicenseParams): __Observable<DataBusLicense> {
    return this.DataBusArchiveLicenseResponse(params).pipe(
      __map(_r => _r.body as DataBusLicense)
    );
  }
}

module DataBusService {

  /**
   * Parameters for DataBusConvertToLicense
   */
  export interface DataBusConvertToLicenseParams {
    validFor: number;
    dataBusStatusId: number;
    customerId: number;
  }

  /**
   * Parameters for DataBusRequestLicense
   */
  export interface DataBusRequestLicenseParams {
    uriCount?: number;
    ServerToken?: null | string;
    ServerName?: null | string;
    LicensePlugins?: null | Array<string>;
    EmailAddress?: null | string;
  }

  /**
   * Parameters for DataBusSaveOrderForUser
   */
  export interface DataBusSaveOrderForUserParams {
    uriCount?: number;
    totalPrice?: number;
    licensesPlugins?: null | Array<string>;
    licenseName?: null | string;
    customerId?: number;
  }

  /**
   * Parameters for DataBusCreateOrderForUser
   */
  export interface DataBusCreateOrderForUserParams {
    orderId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DataBusApproveOrder
   */
  export interface DataBusApproveOrderParams {
    orderId: number;
    validDays?: null | number;
  }

  /**
   * Parameters for DataBusGetLicenseFile
   */
  export interface DataBusGetLicenseFileParams {
    licenseId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DataBusGenerateLicenseFile
   */
  export interface DataBusGenerateLicenseFileParams {
    serverToken?: null | string;
    licenseId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DataBusUpdateLicense
   */
  export interface DataBusUpdateLicenseParams {
    uriCount?: number;
    totalPrice?: number;
    licensesPlugins?: null | Array<string>;
    licenseName?: null | string;
    licenseId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DataBusGetLicenseById
   */
  export interface DataBusGetLicenseByIdParams {
    licenseId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DataBusRevokeLicense
   */
  export interface DataBusRevokeLicenseParams {
    licenseId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DataBusRenewLicense
   */
  export interface DataBusRenewLicenseParams {
    licenseId?: number;
    customerId?: number;
  }

  /**
   * Parameters for DataBusArchiveLicense
   */
  export interface DataBusArchiveLicenseParams {
    licenseId?: number;
    customerId?: number;
  }
}

export { DataBusService }
